import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'new/elements/Form/useForm';
import { useSelector } from 'react-redux';
import { ConnectionLoader } from '../ConnectionLoader/ConnectionLoader';

interface FormLoaderProps {}

export const FormLoader = (props: FormLoaderProps) => {
  const { loaderMessages } = useForm();
  const request = useSelector((state: any) => state.request);
  const [activeIndex, setActiveIndex] = useState(null);
  const timeoutRef = useRef(null);

  let loading: boolean, message: string;

  useEffect(() => {
    if (Array.isArray(loaderMessages)) {
      setActiveIndex(0);
    }
  }, [loaderMessages]);

  if (typeof loaderMessages == 'string') {
    loading = true;
    message = loaderMessages;
  } else if (Array.isArray(loaderMessages)) {
    if (activeIndex !== null) {
      message = loaderMessages[activeIndex]?.message;
      loading = true;
      timeoutRef.current = setTimeout(() => {
        if (activeIndex < loaderMessages.length) {
          setActiveIndex(activeIndex + 1);
        } else {
          setActiveIndex(null);
        }
      }, loaderMessages[activeIndex]?.timeout);
    } else {
      loading = false;
      clearTimeout(timeoutRef.current);
    }
  } else {
    ({ loading, message } = Object.keys(loaderMessages).reduce(
      (result, key) => {
        if (!!request[key]) {
          return { loading: true, message: loaderMessages[key] };
        }
        return result;
      },
      { loading: false, message: '' },
    ));
  }

  return <ConnectionLoader loading={loading} message={message} />;
};
